import { Container, Button,Form, Alert, Modal, Table} from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "./ContentStyles";
import {Pageheight} from "../index";
import React, {useMemo, useState, useEffect } from 'react';
import { FaFilePdf, FaCheck, FaEuroSign, FaShare, FaEdit} from 'react-icons/fa';
import useBackend, {CallAPI, Loading, SpinnerX, Check, Header} from '../services/useBackend';
import {SplitoutLocalDateFromISO} from '../services/misc';
import {CloudPopup} from './common/PopUpX';

export default function MyComponent() {

    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);

    const PopUpResetDatesClickHandler  = React.createRef();
    const PopUpResetDatesClickHandler2  = React.createRef();

    const [invoiceEditModalshow, setInvoiceEditModalshow] = useState(false);
    const [invoiceToEdit, setInvoiceToEdit] = useState({internalComment:''});

    const [totalAmountUnpaid, setTotalAmountUnpaid] = useState(0);
    
    const initInvoiceEditModalshow = () => { return setInvoiceEditModalshow(!invoiceEditModalshow) } 
    
    const {loading:InvoiceDataLoading, data:InvoiceData, Refresh} =  useBackend(process.env.PUBLIC_URL+'/backend/invoices'); 
    
    async function EditClickHandler(event)  {
        event.preventDefault();
        const InvoiceGUID = event.currentTarget.getAttribute("InvoiceGUID")        
        let InvoiceToEdit = InvoiceData.invoices.find(TLI=>TLI.guid==InvoiceGUID);
        setInvoiceToEdit(InvoiceToEdit);
        initInvoiceEditModalshow();
        console.log(JSON.stringify(InvoiceToEdit));
    }
    
    const ResetDatesClickHandler = async (event)  =>  {
        event.preventDefault();   
        console.log("ResetDatesClickHandler: "+ invoiceToEdit.guid);
        await PopUpResetDatesClickHandler.current.hidePopup();
        var formDataObj = {SystemID:"C", InvoiceData : {ResetDates : true}}; 

        setSpinnerHidden(false);
        var {resultVariant, resultVisible, resultText, errorsException} = await CallAPI(process.env.PUBLIC_URL+"/backend/invoices/"+invoiceToEdit.guid,"PUT", JSON.stringify(formDataObj));
        setSpinnerHidden(true);
        setResultVisible(resultVisible);
        setResultText(resultText);
        setResultVariant(resultVariant);
        Refresh();
    }

    const SendInvoiceHandle = async (event)  =>  {
        event.preventDefault();   
        console.log("SendInvoiceHandle: "+ invoiceToEdit.guid);
        await PopUpResetDatesClickHandler2.current.hidePopup();
        var formDataObj = {SystemID:"C", InvoiceData : {Send : true}}; 

        setSpinnerHidden(false);
        var {resultVariant, resultVisible, resultText, errorsException} = await CallAPI(process.env.PUBLIC_URL+"/backend/invoices/"+invoiceToEdit.guid,"PUT", JSON.stringify(formDataObj));
        setSpinnerHidden(true);
        setResultVisible(resultVisible);
        setResultText(resultText);
        setResultVariant(resultVariant);
        Refresh();   
    }
    
    const SendReminderHandle = (event)  =>  {
        event.preventDefault();   
        console.log("SendReminderHandle: "+ invoiceToEdit.guid);
    }      
    
    const MarkAsPayedClickHandler = (event)  =>  {
        event.preventDefault();   
        console.log("MarkAsPayedClickHandler: "+ invoiceToEdit.guid);
    }
    
    const MarkAsSentClickHandler = (event)  =>  {
        event.preventDefault();   
        console.log("MarkAsSentClickHandler: "+ invoiceToEdit.guid);
    }          
        
    if (!InvoiceDataLoading) {
        return (
            <ContentWrapper>
                <Container>
                <Sida style={{minHeight:Pageheight(400)}}>
                    <Header Title="Invoicing">Total amount unpaid: {InvoiceData.totalAmountUnpaid}</Header>
                    <StyckeCompact>
                            <Table  responsive="sm"  class="gridtable">
                                <thead>
                                    <tr>    <td>Identity</td><td className="d-lg-block d-none">Created</td><td>Customer</td><td className="d-lg-block d-none">Int. Comment</td><td>Unpaid</td> <td>Sent</td> <td>Payed</td> <td>Action</td>   </tr>
                                </thead>
                                <tbody>
                                    {InvoiceData.invoices.map((item) => {
                                        return <tr>                                         
                                         <td><a href={'/invoicing/details/'+item.guid}>{item.identifier}</a></td> <td className="d-lg-block d-none">{item.created}</td> <td><small>{item.customer}</small></td>  <td className="d-lg-block d-none"><small>{item.internalComment}</small></td> <td>{item.amount}</td>
                                         <td><FaCheck hidden={!item.sent}/></td>
                                         <td><FaCheck hidden={!item.payed}/></td>
                                         <td>   <a href={'/backend/invoices/'+item.guid} target="_blank"><FaFilePdf /></a>&nbsp;&nbsp;
                                                <a href={'/invoicing/details/'+item.guid} ><FaEdit /></a>&nbsp;&nbsp;
                                                <a InvoiceGUID = {item.guid} href="" onClick={EditClickHandler} ><FaEdit /></a>&nbsp;&nbsp;
                                         </td>
                                         </tr>
                                    })}
                                </tbody>
                            </Table>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                    </StyckeCompact>                  

                    <Modal show={invoiceEditModalshow} onHide={initInvoiceEditModalshow}>
                        <Modal.Header closeButton>
                            <Modal.Title>Registrera Tid/matrial</Modal.Title>                            
                        </Modal.Header>                            
                        <Modal.Body>

                                <div style={{width:"90%"}}>
                                    <Form id="FrmTimeLogAdd">                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Comment</Form.Label>
                                            <Form.Control type="text" name ="Comment" placeholder="Comment" defaultValue={invoiceToEdit.internalComment} />
                                        </Form.Group>                                
                                    </Form> 
                                </div>

                            <Form.Group className="mb-3"  hidden={spinnerHidden}>
                                <SpinnerX  />
                            </Form.Group>                      

                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                               

                        </Modal.Body>

                        <Modal.Footer>
                            <CloudPopup ref={PopUpResetDatesClickHandler2} caption="Send Invoice" className="CloudButton" variant="primary" showByDefault="false" showClose="true">
                                Do you want to send?<br></br>
                                <Button className="CloudButton" variant="primary" type="button" onClick={SendInvoiceHandle}>Yes</Button>&nbsp;
                            </CloudPopup>

                            <CloudPopup caption="Send Reminder" className="CloudButton" variant="primary" showByDefault="false" showClose="true">
                                Do you want to send a reminder?<br></br>
                                <Button className="CloudButton" variant="primary" type="button" onClick={SendReminderHandle}>Yes</Button>&nbsp;      
                            </CloudPopup>

                            <CloudPopup caption="Mark as payed" className="CloudButton" variant="primary" showByDefault="false" showClose="true">
                                Do you want to set state to payed?<br></br>
                                <Button className="CloudButton" variant="primary" type="button" onClick={MarkAsPayedClickHandler}>Yes</Button>&nbsp;
                            </CloudPopup>

                            <CloudPopup ref={PopUpResetDatesClickHandler} caption="Reset dates" className="CloudButton" variant="primary" showByDefault="false" showClose="true">
                                Do you want to reset dates?<br></br>                                
                                <Button className="CloudButton" variant="primary" type="button" onClick={ResetDatesClickHandler}>Yes</Button>&nbsp;                                
                            </CloudPopup>    

                            <CloudPopup caption="Mark as sent" className="CloudButton" variant="primary" showByDefault="false" showClose="true">
                                Do you want to set state sent?<br></br>
                                <Button className="CloudButton" variant="primary" type="button" onClick={MarkAsSentClickHandler}>Yes</Button>&nbsp;
                            </CloudPopup>                            
                            <Button variant="danger" onClick={initInvoiceEditModalshow}>Avbryt</Button>                            
                        </Modal.Footer>                            

                    </Modal>

                    </Sida>
                </Container>
            </ContentWrapper>    
        );        
    } else {
        return (<Loading />);        
    }
}